import { useEffect, useState } from 'react';
import { autorun } from 'mobx';
import { observer } from 'mobx-react-lite';
import { Wire } from 'src/services/Wire';
import { EmfitStore } from '../../stores/EmfitStore';
import { DeviceStatus } from '@emfit/shared-types';

const StatusLabel: Record<number, string> = {
  [DeviceStatus.Presence]: 'In bed',
  [DeviceStatus.Absence]: 'Out of bed',
  [DeviceStatus.NetworkError]: 'No data',
  [DeviceStatus.SensorError]: 'Sensor error',
  [DeviceStatus.Undeployed]: 'Not active',
};

export const StatusAnnouncer = observer(() => {
  const [message, setMessage] = useState('');

  useEffect(() => {
    const prevStatuses: Record<string, number> = {};
    for (const [id, dto] of Object.entries(Wire.deviceStatus)) {
      prevStatuses[id] = dto.status;
    }

    const dispose = autorun(() => {
      for (const [id, dto] of Object.entries(Wire.deviceStatus)) {
        if (prevStatuses[id] !== dto.status) {
          prevStatuses[id] = dto.status;
          const deviceStore = EmfitStore.devices.find((d) => d.id === id);
          const label =
            deviceStore?.device.device_name ||
            deviceStore?.device.serial_number ||
            id;
          const statusLabel = StatusLabel[dto.status] ?? 'status changed';
          setMessage(`${label}: ${statusLabel}`);
          setTimeout(() => setMessage(''), 5000);
        }
      }
    });

    return dispose;
  }, []);

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="sr-only"
    >
      {message}
    </div>
  );
});
